/* eslint-disable */
import convertList from '../convertList';

function getListById(data) {
    return new Promise((resolve, reject) => {
        qdp.getTroopMemberListById({
            id: data.groupId,
            success(res) {
                resolve(res);
            },
            fail(res) {
                reject(res);
            }
        });
    });
}

export default function(config) {
    const moreConfig = {
        totalState: false
    };

    return new Promise((resolve, reject) => {
        const data = {
            groupId: config.groupId
        };
        getListById(data).then(
            res => {
                console.log('test1:', res)
                if (res.data && res.data.memberList.length) {
                    const newList = convertList(
                            res.data.memberList,
                            {
                                groupId: 'id',
                                list: 'memberList'
                            },
                            moreConfig,
                            config.nodeId
                        );
                    const result = Object.assign(res.data, {
                        list: newList
                    })
                    resolve(result);
                } else {
                    resolve({
                        list: []
                    });
                }
            },
            err => {
                reject(err);
            }
        );
    });
}
